<template>
<div class="container mx-auto bg-white px-5 py-5 md:p-20 main-container">
  <slot></slot>
</div>
</template>

<script>
export default {
  name: 'MainContainer'
}
</script>

<style scoped>
.main-container {
  min-width: 320px;
}
</style>
